import React from 'react';
import { useTranslation } from 'react-i18next';
import { getControlStyle, setImage } from '../../helper';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import noImage from '../../../assets/images/no-image.png';

export function URLLink(props) {
  const { t } = useTranslation('common');

  const {
    fromForm,
    dataIndex,
    editingInput,
    deleteItem,
    url,
    replacementText,
    thumbnailURL,
    metaData,
    showTitle,
    showDescription,
    dppAddEditAccess,
    otherConfiguration,
    isProductArchived,
  } = props;
  const urlData = () => {
    return url ? (
      <a target="_blank" href={url} className="d-block" style={getControlStyle(otherConfiguration, 'urlAlignment', 'urlColour', 'urlBold')} rel="noreferrer">
        {replacementText || url}
      </a>
    ) : (
      <div className="empty-heading">{t('DPP.CONTROL.URL_LINK.URL_PLACEHOLDER')}</div>
    );
  };
  const getImageSrc = () => {
    if (metaData?.image?.includes('url_link')) {
      return setImage(metaData?.image);
    }
    return metaData?.image || noImage;
  };

  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  const renderThumbnail = () => {
    if (!thumbnailURL) return null;
    const content = (
      <>
        <figure>
          <img src={getImageSrc()} className="img-fluid" alt="" onError={handleImageError} />
        </figure>
        {showTitle && <p className="title">{metaData?.title}</p>}
        {showDescription && <p className="desc">{metaData?.description}</p>}
      </>
    );
    const style = getControlStyle(otherConfiguration, 'urlAlignment', 'urlColour', 'urlBold');
    if (url) {
      return (
        <a target="_blank" href={url} className="thumbnail-url-container d-block" style={style} rel="noreferrer">
          {content}
        </a>
      );
    }
    return (
      <div className="thumbnail-url-container" style={style}>
        {content}
      </div>
    );
  };
  return (
    <div className="url-link-control">
      {thumbnailURL ? renderThumbnail() : urlData()}

      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={isProductArchived}
        />
      )}
    </div>
  );
}
export default URLLink;
